export default function (nga, admin) {

    let entity = admin.getEntity('variable')
        .label('Variables');

    entity.listView()
        .fields([
            nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'),
            nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'),
            nga.field('abbreviation').label('ABBREVIATION'),
            nga.field('description').label('DESCRIPTION'),
            nga.field('type').label('TYPE')
        ])
        .sortDir('asc')
        .url('variables');


    entity.creationView()
        .fields([
            nga.field('name').label('NAME'),
            nga.field('abbreviation').label('ABBREVIATION'),
            nga.field('description').label('DESCRIPTION'),
            nga.field('type', 'choice').label('TYPE')
                .choices([
                    {label: 'FLOAT', value: 'float'},
                    {label: 'INTEGER', value: 'int'},
                    {label: 'BOOLEAN', value: 'boolean'},
                    {label: 'MULTIPLE', value: 'multiple'},
                    {label: 'REPETITIONS', value: 'repetitions'}
                ]).defaultValue('float'),
            nga.field('max'),
            nga.field('min'),
            nga.field('modify_fixed').label('MODIFY_FIXED'),
            nga.field('steps').label('STEPS')
        ]);

    entity.showView()
        .fields(
            entity.creationView().fields(),
            nga.field('modify_relation', 'embedded_list').label('MODIFY_RELATION')
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('key').label('KEY')
                        .label('PERCENTAGE'),
                    nga.field('value').label('VALUE')
                ]),
            nga.field('modify_variable', 'embedded_list').label('MODIFY_FIXED')
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('key').label('KEY')
                        .label('PERCENTAGE'),
                    nga.field('value').label('VALUE')
                ]),
            nga.field('hardness_initial', 'embedded_list').label('HARDNESS_INITIAL')
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('key').label('KEY')
                        .label('GROUP'),
                    nga.field('value').label('VALUE')
                        .label('HARDNESS')
                ]),
            nga.field('games', 'referenced_list')
                .label('GAMES')
                .targetEntity(nga.entity('config').url('configs'))
                .targetReferenceField('variable')
                .targetFields([
                    nga.field('game').label('GAME')
                        .map(function (value, entry) {
                            if (entry['game.name'])
                                return entry['game.name'];
                        })
                        .template('<entity-show type="\'game\'" id="::entry.values[\'game.id\']" text="value"></entity-show>'),
                ])
        );

    entity.creationView()
        .fields(
            nga.field('modify_relation', 'embedded_list').label('MODIFY_RELATION')
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('key').label('KEY')
                        .label('PERCENTAGE'),
                    nga.field('value').label('VALUE')
                ])
                .template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array'),
            nga.field('modify_variable', 'embedded_list').label('MODIFY_VARIABLE')
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('key').label('KEY')
                        .label('PERCENTAGE'),
                    nga.field('value').label('VALUE')
                ])
                .template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array'),
            nga.field('hardness_initial', 'embedded_list').label('HARDNESS_INITIAL')
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('key').label('KEY')
                        .label('GROUP'),
                    nga.field('value').label('VALUE')
                        .label('HARDNESS')
                ])
                .template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array')
        )

    entity.editionView()
        .fields(entity.creationView().fields());
    entity.deletionView();

    return entity;
}


/** WEBPACK FOOTER **
 ** ./js/entities/variable/config.js
 **/